// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"c3c807a0","419":"70c53d92","563":"4d555e47","942":"ec51c568"}[chunkId] + ".chunk.js";
};